/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { processCustomDoubtDetails } from '@api/processors/custom-doubts';
import useFetch from '@hooks/useFetch';

const useDoubtDetailsWithoutAuth = (
  goalUID,
  doubtUID,
  options = { fallbackData: undefined },
  selectorFunc = null
) => {
  const key = doubtUID
    ? `v2/doubts/learner/solutions?add_title_and_tag=true&doubt_uid=${doubtUID}&goal_uid=${goalUID}&is_fast_doubts_flow=true`
    : undefined;
  const {
    data: doubtDetailsData,
    mutate,
    ...rest
  } = useFetch(
    key,
    { useCamelCase: false },
    { fallbackData: options.fallbackData }
  );

  const processedDoubtDetails = useMemo(
    () =>
      doubtDetailsData?.errorCode
        ? doubtDetailsData
        : processCustomDoubtDetails(doubtDetailsData, options.isSelectedReset),
    [doubtDetailsData, processCustomDoubtDetails, options.isSelectedReset]
  );

  if (typeof selectorFunc === 'function')
    return selectorFunc(processedDoubtDetails);

  return {
    key,
    mutate,
    doubtDetailsData: processedDoubtDetails,
    ...rest
  };
};

export default useDoubtDetailsWithoutAuth;
